module.exports = __webpack_public_path__ + "media/bootstrap-icons/plug-e50c3990.svg";